<template>
  <v-container fluid class="credential-page pa-4 pa-md-8">
    <v-row class="fill-height" align="center" justify="center">
      <v-col cols="12" sm="10" md="7" lg="5">
        <v-card class="credential-card" rounded="xl" elevation="8">
          <v-card-text class="pa-6 pa-md-8">
            <v-row class="mb-4" justify="center">
              <v-col cols="12" class="text-center">
                <v-img src="../assets/logo3.png" contain max-height="96" />
              </v-col>
            </v-row>

            <h1 class="credential-title text-center mb-2">Activa tu credencial</h1>
            <p class="credential-subtitle text-center mb-6">
              <span v-if="userData">
                Hola {{ userData.nombre }},<br>
                puedes ingresar una contraseña que activará su acceso a Rutas Meigas Agencia como usuario de la agencia
                {{ userData.origen ? userData.origen.nombre : "" }}.<br>
                Tu nombre de usuario es: <strong>{{ userData.username }}</strong>
              </span>
              <span v-else>
                Define una nueva contraseña para acceder al portal de agencias.
              </span>
            </p>

            <v-form @submit.prevent="_cambiarCredencialAgencia">
              <v-text-field
                v-model="password"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPassword ? 'text' : 'password'"
                label="Nueva contraseña"
                outlined
                dense
                background-color="white"
                autocomplete="new-password"
                @click:append="showPassword = !showPassword"
              />

              <v-text-field
                v-model="passwordConfirmation"
                :append-icon="showPasswordConfirmation ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPasswordConfirmation ? 'text' : 'password'"
                label="Confirmar contraseña"
                outlined
                dense
                background-color="white"
                autocomplete="new-password"
                @click:append="showPasswordConfirmation = !showPasswordConfirmation"
              />

              <div class="rules-box mb-4">
                <div class="rule-item" :class="{ 'rule-item--ok': hasMinLength }">
                  Mínimo 8 caracteres
                </div>
                <div class="rule-item" :class="{ 'rule-item--ok': hasNumber }">
                  Al menos 1 número
                </div>
                <div class="rule-item" :class="{ 'rule-item--ok': hasUppercase }">
                  Al menos 1 mayúscula
                </div>
                <div class="rule-item" :class="{ 'rule-item--ok': hasSymbol }">
                  Al menos 1 signo
                </div>
                <div class="rule-item" :class="{ 'rule-item--ok': passwordsMatch }">
                  La contraseña y la confirmación deben coincidir
                </div>
              </div>

              <v-alert v-if="errorMessage" type="error" dense outlined class="mb-4">
                {{ errorMessage }}
              </v-alert>

              <v-alert v-if="successMessage" type="success" dense outlined class="mb-4">
                {{ successMessage }}
              </v-alert>

              <v-btn
                block
                large
                rounded
                elevation="0"
                class="action-btn"
                color="#FF9C00"
                :disabled="!formValida || enviando"
                type="submit"
              >
                <span v-if="enviando">Cambiando...</span>
                <span v-else>Cambiar contraseña</span>
              </v-btn>

              <v-btn
                v-if="successMessage"
                block
                large
                rounded
                elevation="0"
                class="action-btn mt-4"
                color="#191970"
                href="https://centralreservas.rutasmeigas.com/"
              >
                Acceder
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      password: "",
      passwordConfirmation: "",
      showPassword: false,
      showPasswordConfirmation: false,
      enviando: false,
      cargandoUsuario: false,
      errorMessage: "",
      successMessage: "",
      userData: null,
    };
  },
  computed: {
    hash() {
      return this.$route.params.hash || "";
    },
    hasMinLength() {
      return this.password.length >= 8;
    },
    hasNumber() {
      return /\d/.test(this.password);
    },
    hasUppercase() {
      return /[A-Z]/.test(this.password);
    },
    hasSymbol() {
      return /[^A-Za-z0-9]/.test(this.password);
    },
    passwordsMatch() {
      return this.passwordConfirmation.length > 0 && this.password === this.passwordConfirmation;
    },
    formValida() {
      return this.hasMinLength &&
        this.hasNumber &&
        this.hasUppercase &&
        this.hasSymbol &&
        this.passwordsMatch;
    },
  },
  mounted() {
    this._getUserByHash();
  },
  methods: {
    ...mapActions("reservas", ["cambiarCredencialAgencia", "getUserByHash"]),

    async _getUserByHash() {
      if (!this.hash) {
        this.errorMessage = "El enlace de activación no es válido.";
        return;
      }

      this.cargandoUsuario = true;
      const response = await this.getUserByHash([this.hash]);

      if (response) {
        this.userData = response;
      } else {
        this.errorMessage = "No se pudo validar el enlace de activación.";
      }

      this.cargandoUsuario = false;
    },

    async _cambiarCredencialAgencia() {
      if (!this.formValida || this.enviando || !this.hash) {
        return;
      }

      this.errorMessage = "";
      this.successMessage = "";
      this.enviando = true;

      const response = await this.cambiarCredencialAgencia([
        this.hash,
        this.password,
        this.passwordConfirmation,
      ]);

      if (response) {
        this.successMessage = "La contraseña se ha actualizado correctamente.";
        this.password = "";
        this.passwordConfirmation = "";
      } else {
        this.errorMessage = "No se pudo cambiar la contraseña. Inténtalo de nuevo.";
      }

      this.enviando = false;
    },
  },
};
</script>

<style scoped>
.credential-page {
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(25, 25, 112, 0.16), transparent 35%),
    radial-gradient(circle at bottom right, rgba(255, 156, 0, 0.22), transparent 34%),
    #f6f1e6;
}

.credential-card {
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.96);
}

.credential-title {
  color: #191970;
  font-size: 2rem;
  line-height: 1.1;
}

.credential-subtitle {
  color: #43506b;
  font-size: 1rem;
}

.rules-box {
  padding: 16px;
  border-radius: 16px;
  background: #fff6e5;
  border: 1px solid rgba(255, 156, 0, 0.2);
}

.rule-item {
  color: #c62828;
  font-size: 0.95rem;
  font-weight: 600;
}

.rule-item + .rule-item {
  margin-top: 8px;
}

.rule-item--ok {
  color: #2e7d32;
}

.action-btn {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 700;
  color: #ffffff !important;
}

.action-btn.v-btn--disabled {
  opacity: 1 !important;
  color: rgba(255, 255, 255, 0.9) !important;
}

.action-btn.v-btn--disabled:not(.v-btn--text):not(.v-btn--outlined):not(.v-btn--icon) {
  background-color: rgba(255, 156, 0, 0.65) !important;
}
</style>
